/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const SaveInventoryPopup = ({
  afterPopupCLose = () => {},
  inventoryId = null,
  setInventoryId = () => {},
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const [productInput, setproductInput] = useState("");
  const [productList, setproductList] = useState([]);

  const [addressInput, setaddressInput] = useState("");
  const [addressList, setaddressList] = useState([]);

  const [productValue, setproductValue] = useState(null);
  const [productId, setProductId] = useState(null);
  const [addressvalue, setaddressvalue] = useState(null);
  const [addressId, setaddressId] = useState(null);
  const [stockAdded, setstockAdded] = useState("");
  const [supplier, setsupplier] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  /* hook for validation */
  const [errors, setErrors] = useState({});

  /* function to validate form */
  const validationHandler = () => {
    const newErrors = {};

    if (productId === null) {
      newErrors.product = t("A product must be selected to continue.");
    }

    if (stockAdded === "" || Number(stockAdded) <= 0) {
      newErrors.stock = t("Stock quantity must be a number greater than 0.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for product list
  const getProductList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_PRODUCTS_LIST +
        `?token=${token}&title=${productInput}`;

      const response = await getData(requestUrl);

      console.log("response in product list------>", response);

      if (response.status) {
        setproductList(response.data);
      }
    } catch (error) {}
  };

  //fucntion for get addresslist
  const getAddressList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_WAREHOUSE_ADDRESS + `?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setaddressList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //select product
  const productSelectionHandler = (val) => {
    if (errors.product) {
      setErrors((prev) => ({ ...prev, product: "" }));
    }
    if (val) {
      setproductValue(val);
      setProductId(val.value);
    } else {
      setproductInput("");
      setproductList([]);
      setproductValue(null);
      setProductId(null);
    }
  };

  //select address
  const addressSelectionHandler = (val) => {
    setValidation((prevState) => ({ ...prevState, addressWarning: false }));
    if (val) {
      setaddressvalue(val);
      setaddressId(val.value);
    } else {
      setaddressvalue(null);
      setaddressId(null);
    }
  };

  //get details
  const getDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_INVENTORY_DETAILS +
        `/${inventoryId}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        const data = response.data;

        if (data.productvalue) {
          productSelectionHandler(data.productvalue);
        }

        if (data.addressvalue) {
          addressSelectionHandler(data.addressvalue);
        }

        setstockAdded(data.stockadded);
        setsupplier(data.supplier);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for create new tag
  const saveInventoryHandler = async () => {
    if (!validationHandler()) {
      return;
    }

    setIsSaving(true);

    try {
      let sendingData = {
        productid: productId,
        warehouse: addressId,
        supplier,
        stockadded: stockAdded,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (inventoryId) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_INVENTORY +
          `/${inventoryId}` +
          `?token=${token}`;

        response = await putData(requestUrl, sendingData);
      } else {
        requestUrl = requestUrl + url.API_CREATE_INVENTORY + `?token=${token}`;

        response = await postData(requestUrl, sendingData);
      }

      setIsSaving(false);
      console.log(response);

      if (response.status) {
        // close the modal of addLabel
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#offcanvasSaveInventory")
        ).hide();
        resetHandler();
        afterPopupCLose();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  /* reset */
  const resetHandler = () => {
    setproductInput("");
    setproductList([]);
    setaddressId(null);
    setaddressvalue(null);
    setProductId(null);
    setproductValue(null);
    setstockAdded("");
    setsupplier("");

    setInventoryId(null);

    setErrors({});
  };

  useEffect(() => {
    if (inventoryId) {
      getDetails();
    }
  }, [inventoryId]);

  useEffect(() => {
    getAddressList();
  }, []);

  useEffect(() => {
    if (productInput.length > 1) {
      getProductList();
    }
  }, [productInput]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.product ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.product ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasSaveInventory"
      aria-labelledby="offcanvasSaveInventory"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              inventory_2
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {inventoryId ? t("Edit Stock") : t("Save Stock to Inventory")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {inventoryId
                ? t("Manage existing stock details")
                : t("Add new stock to inventory")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="productName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Product Name")}
                </label>
                <Select
                  isClearable
                  placeholder={t("Search and select a product by name")}
                  styles={customStyles}
                  options={productList}
                  value={productValue}
                  onChange={productSelectionHandler}
                  onInputChange={(val) => {
                    setproductInput(val);
                    if (errors.product) {
                      setErrors((prev) => ({ ...prev, product: "" }));
                    }
                  }}
                />
                {errors.product && (
                  <div className="invalid-feedback d-block">
                    {errors.product}
                  </div>
                )}
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="warehouse"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Warehouse")}
                </label>
                <Select
                  isClearable
                  placeholder={t("Choose a warehouse location")}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  options={addressList}
                  value={addressvalue}
                  onChange={addressSelectionHandler}
                />
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="currentStock"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Stock Added")}
                </label>
                <input
                  type="number"
                  id="currentStock"
                  placeholder={t("e.g., 50")}
                  className={`form-control fs-sm shadow-none ${
                    errors.stock ? "is-invalid" : "border border-gray-300"
                  }`}
                  value={stockAdded}
                  onChange={(e) => {
                    setstockAdded(e.target.value);
                    if (errors.stock) {
                      setErrors((prev) => ({ ...prev, stock: "" }));
                    }
                  }}
                />
                {errors.stock && (
                  <div className="invalid-feedback d-block">{errors.stock}</div>
                )}
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="supplier"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Supplier")}
                </label>
                <input
                  type="text"
                  id="supplier"
                  placeholder={t("Enter supplier name or reference")}
                  className="form-control fs-sm shadow-none border border-gray-300"
                  value={supplier}
                  onChange={(e) => {
                    setsupplier(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveInventoryHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Inventory")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveInventoryPopup;
